module.exports = __webpack_public_path__ + "img/SOL-icon.a13dd805.svg";